import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledCancelTripModal = styled.div`
  .canceltrip_modal_body {
    max-height: 100%;
  }
  .modal_loader {
    &__heading {
      width: 40%;
      height: ${toRem(24)};
    }
    &__body {
      width: 80%;
      height: ${toRem(24)};
    }
  }
`;
